<template>
  <div>
    <b-row align-h="end">
      <b-col cols="2">
        <b-button
          variant="primary"
          v-on:click="excelIndir()"
          style="margin-bottom: 15px; margin-top: 15px"
          size="sm"
        >
          <download-excel
            v-if="!isMobile()"
            class="btn btn-default"
            :data="excelYadirData"
            name="excelData.xls"
            style="
              width: 75px;
              height: 25px;
              text-align: center;
              padding: 0px;
              color: white;
              border-style: solid;
              border-color: #0d6efd;
              border-radius: 5px;
              background-color: #0d6efd;
            "
          >
            Excel
          </download-excel>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import { BButton } from "bootstrap-vue";
export default {
  props: ["excelData"],
  components: {
    BButton,
  },
  data() {
    return {
      isMobile: function () {
        return isMobile;
      },
      excelYadirData: [],
    };
  },
  methods: {
    excelIndir() {
   //   alert("in");
      console.log(this.excelData);
      this.excelYadirData = this.excelData;
    },
  },
  created() {
    // alert("in");
    //   this.excelYadirData = this.excelData;
  },
};
</script>